import React from 'react';
import { Grid, GridItem } from '../../../Grid';
import { TextInputProps } from '../../TextInput';
import { DayOrMonthInput } from '../styles';

/* Used for the day/month fields in the Date Input, and is also exposed so that other form
fields can align in the same way, e.g. CVV number in payment form */
const NarrowTextInput: React.FC<TextInputProps> = ({ ...props }) => (
  <Grid alignLeft>
    <GridItem desktop={4} tabletLandscape={4} tabletPortrait={4}>
      <DayOrMonthInput {...props} />
    </GridItem>
  </Grid>
);

export default NarrowTextInput;
